var m = require('mithril');
var moment = require('moment');
var edit = require('../../layout/components/edit');
var dragscroll = require('../../libs/dragscroll');
var Model = require('../../libs/Model');
var session = require('../../auth/models/session');
var button = require('../../components/button');
var modalForm = require('../../layout/components/modalForm');
var hoverableDropdownDiv = require('../../components/hoverableDropdownDiv');
var hasEquipmentModal = require('./hasEquipmentModal');

var pointDocument = modalForm(Object.assign(require('../../../../../models/documents/Document'), Model));
var dateFormat = 'MM/DD/YYYY';

var megaMenu = {};

megaMenu.oninit = function(vnode) {
  vnode.state.openDropdownId = null;
}

megaMenu.view = function(vnode) { 
  function toggleDropdown(dropdownId) {
    if (vnode.state.openDropdownId === dropdownId) {
      vnode.state.openDropdownId = null; // Close the dropdown if it's already open
    } else {
      vnode.state.openDropdownId = dropdownId; // Open the new dropdown
    }
  }
  
  function handleMouseOver(dropdownId) {
    vnode.state.openDropdownId = dropdownId;
  }

  function handleMouseOut() {
    vnode.state.openDropdownId = null;
  }

  return m('div.mb3.justify-between.flex.flex-wrap', {
    style: {
      'position': 'relative'
    }
  },[
    m('div.flex.flex-wrap', [
      m(hoverableDropdownDiv, {
        menuTitle: 'Documents',
        menuId: 'menu-documents',
        mainDivClass: '.mr2',
        isOpen: vnode.state.openDropdownId === 'menu-documents',
        toggleDropdown: toggleDropdown,
        onMouseOver: () => handleMouseOver('menu-documents'),
        onMouseOut: handleMouseOut,
        content: m('div.mv1', [
          m('div.dragscroll-container', {
            style: {
              'margin-right': '0px'
            }
          },[
            m('div.dragscroll', {oncreate:dragscroll}, [
              m('table.fw2.f3.w-100.pr3', [
                m('thead', [
                  m('tr.relative', [
                    m('th.br.tl.bt-0.bl-0.b--dotted.bw1.fw2', {style: {width: '30%'}},'Name'),
                    m('th.br.tl.bt-0.bl-0.b--dotted.bw1.fw2', {style: {width: '30%'}},'Description'),
                    m('th.br.tl.bt-0.bl-0.b--dotted.bw1.fw2', {style: {width: '20%'}},'Date Uploaded'),
                    m('th.br.tl.bt-0.bl-0.b--dotted.bw1.fw2', {style: {width: '20%'}},'Actions')
                  ])
                ]),
                m('tbody', [
                  (vnode.attrs.systemRecord().out_AttachmentOf ||[]).map(function (documentRecord) {
                    return m('tr', [
                      m('td.bb.tl.moon-gray.tl.nowrap', documentRecord.in.name),
                      m('td.bb.tl.moon-gray.tl.nowrap',  documentRecord.in.description),
                      m('td.bb.tl.moon-gray.tl.nowrap',  moment(parseInt(documentRecord.in.uploadedDate)).format(dateFormat)),
                      m('td.bb.tl.moon-gray.tl.nowrap.tc', [
                        m('i.ion-ios-cloud-download.blue', {
                          style: {cursor: 'pointer'},
                          onclick: function () {
                            var param = encodeURIComponent(documentRecord.in.filename);
                            window.open( 
                              `/api/v1/getDocument?filename=${param}`, "_blank"); 
                          },
                        })
                      ])
                    ])
                  })
                ])
              ])
            ])
          ]),
          m('div.cf', [
            session.user().isSuperuser ? m(button,{
                label:'Add Document',
                class: 'w5 mh3 mv4 fr',
                func:  pointDocument.editDialogue.bind(pointDocument, {parent: vnode.attrs.systemRecord()['@rid'].slice(1)}, {submitCallback: vnode.attrs.submitCallback}),
              })
            : ''
          ])
        ])
      }),
      edit.vm.editing() ?
          [
            m('div.f4',[
              m('div.ba.b--blue.b--dashed.bw1.ph1.h2.flex.items-center', {
                onclick: hasEquipmentModal.editDialogue.bind(hasEquipmentModal, {parentSystem: vnode.attrs.systemRecord()}, { submitCallback: vnode.attrs.submitCallback })
              }, [
                m('div.flex.justify-center.blue', [
                  m('i.ion-plus.mr2'),
                  m('div', 'Add Equipment to System')
                ])
              ])
            ])
          ]
        : ''
    ]),
    m('div.flex', [
      m(hoverableDropdownDiv, {
        menuTitle: 'Connections',
        menuId: 'menu-ports',
        isOpen: vnode.state.openDropdownId === 'menu-ports',
        toggleDropdown: toggleDropdown,
        onMouseOver: () => handleMouseOver('menu-ports'),
        onMouseOut: handleMouseOut,
        content: m('div', [
          m('div.flex.w-100.flex-wrap', [
            m('div.pv1.tc.f4.w-50', 'Incoming'),
            m('div.pv1.tc.f4.w-50', 'Outgoing'),
          ]),
          m('div.flex.w-100.flex-wrap', [
            //TODO: Add incoming and outgoing connections
          ])
        ])
      })
    ])
  ])
}


module.exports = megaMenu;